<template>
  <v-data-table
    :headers="tableHeaders"
    :items="rules"
    hide-default-footer
    disable-pagination
    dense
    class="rules-table"
  >
    <template #item.active="{ item }">
      <v-icon :color="item.active ? 'green' : 'grey'">
        {{ item.active ? "mdi-check-circle" : "mdi-close-circle" }}
      </v-icon>
    </template>

    <template #item.accessPointName="{ item }">
      {{ item.accessPointName }}
    </template>

    <template #item.period="{ item }">
      <span v-if="item.beginDate">
        {{ item.beginDate }} — {{ item.endDate || "Бессрочно" }}
      </span>
      <span v-else>Бессрочно</span>
    </template>

    <template v-if="!readonly" #item.actions="{ item }">
      <create-rule
        :rule="item"
        :type="item.beginDate ? 'expire' : 'infinity'"
        @update-rule="updateRule"
      />
      <v-btn icon @click="deleteRule(item.id)" small>
        <v-icon color="red">mdi-delete</v-icon>
      </v-btn>
    </template>

    <template #no-data>
      <p class="pa-4">Правил нет</p>
    </template>
  </v-data-table>
</template>

<script>
import CreateRule from "./CreateRule";
export default {
  name: "ListTable",
  components: { CreateRule },
  props: {
    rules: Array,
    readonly: { type: Boolean, default: false }
  },

  computed: {
    tableHeaders() {
      const headers = [
        { text: "Активный", value: "active", sortable: false, width: 60 },
        { text: "Точка доступа", value: "accessPointName", sortable: false },
        { text: "Период", value: "period", sortable: false }
      ];
      if (!this.readonly) {
        headers.push({
          text: "",
          value: "actions",
          sortable: false
        });
      }
      return headers;
    }
  },

  methods: {
    updateRule(params) {
      this.$emit("update-rule", params);
    },
    deleteRule(ruleId) {
      this.$emit("delete-rule", ruleId);
    }
  }
};
</script>

<style scoped>
.rules-table >>> tbody tr:hover {
  background-color: transparent !important;
  cursor: default;
}
</style>
